<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Hero from 'components/HeroHome/Hero'
import HeadBar from 'components/block/block-text-header/block-text-header'
import HeadMainBar from 'components/block/block-text-main-header/block-text-main-header'
import TextBox from 'components/block/block-text-box/block-text-box'
import Slider from 'components/custom/custom-slider-multitool/custom-slider-multitool'
import SliderTest from 'components/custom/custom-slider-testimonials/custom-slider-multitool'
import BlockRepeater from 'components/block/block-repeater/block-repeater'
import BlockLinkRepeater from 'components/block/block-link-repeater/block-link-repeater'
import CustomCTABanner from 'components/custom/custom-cta-banner/custom-cta-banner'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Hero,
    HeadMainBar,
    HeadBar,
    TextBox,
    Slider,
    SliderTest,
    BlockRepeater,
    BlockLinkRepeater,
    CustomCTABanner,
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOptionTop: {
        centeredSlides: true,
        loopedSlides: 1,
        loop: true,
        spaceBetween: 30,
        speed: 1000,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        initialSlide: 0
      },
      swiperOptionThumbs: {
        centeredSlides: true,
        loopedSlides: 1,
        loop: true,
        spaceBetween: 10,
        speed: 1000,
        slidesPerView: 3,
        initialSlide: 0,
        touchRatio: 0.2,
        direction: 'vertical',
        slideToClickedSlide: false,
        height: 380
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods: {
    callGa: function (j) {
      if (j === 0) {
        console.log('Desktop Event Phone 1')
        this.$router.push('/about-us')
        setTimeout(() => {
          this.$scrollTo('#doc1')
        },
        500)
      }
      if (j === 1) {
        console.log('Desktop Event Phone 2')
        this.$router.push('/about-us')
        setTimeout(() => {
          this.$scrollTo('#doc2')
        },
        500)
      }
      if (j === 2) {
        console.log('Desktop Event Phone 2')
        this.$router.push('/about-us')
        setTimeout(() => {
          this.$scrollTo('#doc3')
        },
        500)
      }
      if (j === 3) {
        console.log('Desktop Event Phone 2')
        this.$router.push('/about-us')
        setTimeout(() => {
          this.$scrollTo('#doc4')
        },
        500)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?e3a6e9a8